var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "oldInnerWrapper tabContent", attrs: { id: "bilder1" } },
    [
      _c(
        "div",
        { staticClass: "oldSmallImageOuterContainer clearfix" },
        [
          _vm._l(_vm.listElement.elements, function(element, index) {
            return _c(
              "div",
              {
                key: element.resource,
                staticClass: "oldTableContainer oldSmallImageContainer"
              },
              [
                _c("div", { staticClass: "tableRow" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "tableCell textAlignCenter verticalAlignMiddle"
                    },
                    [
                      element.url
                        ? _c("img", { attrs: { src: element.url } })
                        : _vm._e()
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "oldDeleteImageButton",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.listElement.elements.splice(index, 1)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-2x fa-close" })]
                )
              ]
            )
          }),
          _vm._v(" "),
          _vm._l(_vm.files, function(file, index) {
            return _c(
              "div",
              {
                key: file.id,
                class: [
                  "oldTableContainer",
                  "oldSmallImageContainer",
                  file.size > 1024 * 1024 ? "error" : "temp",
                  file.name.length > 255 ? "error" : "temp",
                  file.error ? "error" : "temp"
                ]
              },
              [
                _c("div", { staticClass: "tableRow" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "tableCell textAlignCenter verticalAlignMiddle"
                    },
                    [
                      file.thumb
                        ? _c("img", { attrs: { src: file.thumb } })
                        : _vm._e()
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "oldDeleteImageButton",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.$refs.upload.remove(file)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-2x fa-close" })]
                ),
                _vm._v(" "),
                file.active || file.progress !== "0.00"
                  ? _c("div", { staticClass: "progress old-progress" }, [
                      _c("div", {
                        staticClass: "progress-bar",
                        style: { width: file.progress + "%" },
                        attrs: {
                          role: "progressbar",
                          "aria-valuenow": { width: file.progress + "%" },
                          "aria-valuemin": "0",
                          "aria-valuemax": "100"
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                file.size > 1024 * 1024
                  ? _c("div", { staticClass: "oldImageError" }, [
                      _vm._v("\n                Bild max 1MB\n            ")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                file.name.length > 255
                  ? _c("div", { staticClass: "oldImageError" }, [
                      _vm._v(
                        "\n                Dateiname zu lang\n            "
                      )
                    ])
                  : _vm._e()
              ]
            )
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              class: [
                "oldTableContainer",
                "oldSmallImageContainer",
                "dropzone",
                { active: _vm.$refs.upload && _vm.$refs.upload.dropActive }
              ]
            },
            [_vm._m(0)]
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "file-upload",
        {
          ref: "upload",
          staticClass: "btn btn-white teaserButton width100",
          staticStyle: { "margin-top": "20px" },
          attrs: {
            extensions: "gif,jpg,jpeg,png,webp",
            accept: "image/png,image/gif,image/jpeg,image/webp",
            name: "image",
            "post-action": "/upload/image",
            drop: _vm.drop,
            multiple: _vm.multiple
          },
          on: { "input-filter": _vm.inputFilter, "input-file": _vm.inputFile },
          model: {
            value: _vm.files,
            callback: function($$v) {
              _vm.files = $$v
            },
            expression: "files"
          }
        },
        [_vm._v("\n      Bilder hinzufügen\n    ")]
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "textAlignRight buttonBlockContainerRight" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-white teaserButton width50",
            attrs: { type: "button" },
            on: { click: _vm.cancel }
          },
          [_vm._v("Abbrechen")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-white teaserButton width50",
            attrs: { type: "button", disabled: _vm.uploadHasErrors() },
            on: { click: _vm.save }
          },
          [_vm._v("Speichern")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tableRow" }, [
      _c(
        "div",
        { staticClass: "tableCell textAlignCenter verticalAlignMiddle" },
        [
          _c("div", [_c("i", { staticClass: "fa fa-picture-o fa-2x" })]),
          _vm._v(" "),
          _c("div", [
            _vm._v("\n                        Dein Bild\n                    ")
          ])
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5ebbebbe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ebbebbe","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserContentImages.vue
// module id = 468
// module chunks = 2